import React, { Component } from "react";
import { callApi } from "../../utils/api";
import "../block-download/block_download.css";
import {
    ToastsStore,
    ToastsContainer,
    ToastsContainerPosition,
} from "react-toasts";
import moment from "moment";
import Accordion from "react-bootstrap/Accordion";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import DatePicker from "antd/lib/date-picker";
import Select from 'react-select';
import { toast } from "react-toastify";
import isEmpty from 'lodash/isEmpty';
import RequestShiftExtension from "./RequestShiftExtension";
import { Modal } from "antd";
import { parseCustomDate } from "../dashboard/ExcelVettingReport";
import ExcelJS from "exceljs";
import ReactFlexyTable from "react-flexy-table";
import AlertSlotSettings from "../ShiftExtension/AlertSlotSettings";
import { ADMIN_ROLE } from "../../utils/role";
import { hasPageAccess } from "../../utils/pagePermissionService";

declare var $: any;
interface AllProps {
    history: any;
}
class ShiftDetails extends Component<AllProps> {
    state = {
        shiftDetails: [],
        outreason: "",
        selectVal: false,
        isLoading: false,
        activeTabKey: "Pending",
        page: 1,
        limit: 10,
        totalPages: 1,
        totalCount: 0,
        fromDate: "",
        toDate: "",
        assigned_to: "",
        users: [],
        showShiftModal: false,
        isDownloading: false,
        shiftName: '',
        shiftStartTime: '',
        shiftEndTime: '',
        shiftId: '',
        shiftList: [],
        pageDynamic: [],
    };

    async componentDidMount() {
        this.getOutTime();
        const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
        if (!hasHide) {
            this.ouTime();
        }
        this.getUsers();
        this.getPageDynamicData();

        const currentDate = moment();
        this.setState({
            fromDate: moment(currentDate, "DD.MM.YYYY"),
            toDate: moment(currentDate, "DD.MM.YYYY"),
        }, () => {
            this.listShiftExtensions(this.state.activeTabKey);
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.page !== this.state.page) {
            this.listShiftExtensions(this.state.activeTabKey);
        }
    }

    getPageDynamicData = () => {
        const user: any = localStorage.getItem("user");
        const userDetails = user ? JSON.parse(user) : "";
        let obj = {
            roleId: userDetails ? userDetails.role_id : null,
            userId: userDetails ? userDetails.userId : null,
            roleType: userDetails ? userDetails.roleType : null,
        };
        callApi("POST", "authenticating_pages_list_new.php", obj)
            .then((res) => res.data)
            .then((result) => {
                this.setState({ pageDynamic: result.responseJson.data, });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    listShiftExtensions = (activeKey) => {
        const user = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";
        const role_label = user ? JSON.parse(user)["role_label"] : "";
        // const isAdmin = ["Admin", "Super Admin"].includes(role_label);
        const isAdminAccess = this.state.pageDynamic && this.state.pageDynamic.find((page: any) => page.page_name === "Shift List" && page.status == true);

        const { activeTabKey, page, limit, fromDate, toDate, assigned_to } = this.state;

        const payload = {
            from_dt: fromDate,
            to_dt: toDate,
            user_id: isAdminAccess ? assigned_to : userId,
            status: activeKey ?? activeTabKey,
            page,
            limit
        }
        this.setState({ isLoading: true });
        callApi("POST", "get_shift_extension_requests.php", payload)
            .then(res => res.data)
            .then(response => {
                this.setState({
                    shiftDetails: response.data || [],
                    totalPages: response.total_pages || 1,
                    totalCount: response.total
                });
            })
            .catch(err => {
                console.log(err);
                this.setState({
                    shiftDetails: [],
                    totalPages: 1,
                    totalCount: 0
                });
            })
            .finally(() => {
                this.setState({ isLoading: false });
            });

    };

    handleShift = (e) => {
        e.preventDefault();
        const { shiftId, shiftName, shiftStartTime, shiftEndTime } = this.state;

        const payload = { shiftId, shiftName, shiftStartTime, shiftEndTime }

        const api = isEmpty(shiftId) ? 'insertShift' : 'updateShift';

        callApi("POST", `${api}.php`, payload)
            .then(res => res.data)
            .then(response => {
                if (response.success) {
                    this.getShiftList();
                    $("#shift-create").modal("hide");
                }
            })
            .catch(err => {
                console.log(err);
            });
    }

    getUsers = () => {
        callApi("GET", "user_get.php")
            .then(res => res.data)
            .then(response => {
                this.setState({ users: response.data });
            })
            .catch(err => {
                console.log(err);
            });
    };

    getShiftList = () => {
        callApi("GET", "getShifts.php")
            .then(res => res.data)
            .then(response => {
                if (response.result
                ) {
                    const files = response.data;
                    if (files && files.length > 0) {
                        files.forEach((file, index) => {
                            Object.keys(file).forEach((fileKey) => {
                                file[fileKey] = !file[fileKey]
                                    ? ""
                                    : typeof file[fileKey] !== "string"
                                        ? String(file[fileKey])
                                        : file[fileKey];
                            });
                            file.index = index + 1;
                        });
                    }
                    this.setState({ shiftList: files });
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    previousPop = () => {
        $("#out_reason").modal("show");
        $("#another-reason").modal("hide");
    };
    BacktoFile = () => {
        $("#out_reason").modal("hide");
        const fileid1: any = localStorage.getItem("currentfileId");

        this.props.history.push("/file-dashboard/" + JSON.parse(fileid1));
    };
    getOutTime = () => {
        let date = new Date();
        let stratTime = date.getTime();
        localStorage.setItem("startTime", JSON.stringify(stratTime));
        let outDate = date.toLocaleDateString();
        localStorage.setItem("OutDateGet", JSON.stringify(outDate));
        var Railway = date.getMinutes();
        if (Railway < 10) {
            var TotalMinutes = "0" + Railway;
            let ouTtime = date.getHours() + ":" + TotalMinutes;
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        } else {
            let ouTtime: any = date.getHours() + ":" + date.getMinutes();
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }
    };
    ouTime = () => {
        const getfileId: any = localStorage.getItem("currentfileId");
        if (localStorage.getItem("currentfileId")) {
            $("#out_reason").modal("show");
        }
    };
    outimeGet = () => {
        this.setState({ isLoading: true });
        const fileid1: any = localStorage.getItem("currentfileId");
        const userid1: any = localStorage.getItem("user1");
        const inreason: any = localStorage.getItem("in_reason");
        const intime: any = localStorage.getItem("IntimeGet");
        const outtime: any = localStorage.getItem("outtimeGet");
        const outdate: any = localStorage.getItem("OutDateGet");
        const secondsSpent = moment(outtime, "HH:mm").diff(
            moment(intime, "HH:mm"),
            "seconds"
        );
        const insertId: any = localStorage.getItem("ProcessEodInsertID");
        if (this.state.outreason == "") {
            this.setState({ selectVal: true });
        } else {
            let obj = {
                file_id: JSON.parse(fileid1),
                user_id: JSON.parse(userid1),
                in_reason: JSON.parse(inreason),
                out_reason: this.state.outreason,
                intime: JSON.parse(intime),
                outtime: JSON.parse(outtime),
                insert_date: JSON.parse(outdate),
                total_seconds: secondsSpent,
                "insert_id": insertId
            };

            callApi("POST", "process_eod_insert.php", obj)
                .then((res) => res.data)
                .then((response) => {
                    this.setState({ isLoading: false });
                    localStorage.removeItem("in_reason");
                    localStorage.removeItem("outreason");
                    localStorage.removeItem("IntimeGet");
                    localStorage.removeItem("OutDateGet");
                    $("#out_reason").modal("hide");
                    $("#another-reason").modal("hide");
                    ToastsStore.success("Your Reason Saved Successfully");
                    localStorage.removeItem("currentfileId");
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({ isLoading: false });
                    ToastsStore.error("Your Reason Not Stored");
                });
        }
    };
    onchangeReason = (e: any) => {
        if (e.target.value == "Other") {
            this.setState({ in_reason: "", selectVal: false });
            $("#out_reason").modal("hide");
            $("#another-reason").modal("show");
        } else if (e.target.value == "select") {
            this.setState({ setResponse: false });
        } else {
            this.setState({ [e.target.name]: e.target.value, selectVal: false });
        }
    };

    onchange = (e: any) => {
        this.setState({
            [e.target.name]: e.target.value.replace(/\s+/g, " ").trim(),
            selectVal: false,
        });
    };

    handlePrev = () => {
        this.setState((prev: any) => ({
            page: Math.max(prev.page - 1, 1)
        }));
    };

    handleNext = () => {
        this.setState((prev: any) => ({
            page: Math.min(prev.page + 1, prev.totalPages)
        }));
    };

    handleApprove = (requestId: number) => {
        this.updateShiftExtensionRequest(requestId, 'Approve');
    };

    handleReject = (requestId: number) => {
        this.updateShiftExtensionRequest(requestId, 'Reject');
    };

    updateShiftExtensionRequest = (requestId: number, status: string) => {
        const user = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";

        let reason = "";

        Modal.confirm({
            title: `Do you want to ${status} this request?`,
            content: (
                <div>
                    <p>Please enter the {status.toLowerCase()} reason:</p>
                    <textarea
                        style={{ width: "90%" }}
                        placeholder={`Enter ${status.toLowerCase()} reason`}
                        onChange={(e) => {
                            reason = e.target.value;
                        }}
                    />
                </div>
            ),
            okText: "Submit",
            cancelText: "Cancel",
            onOk: () => {
                if (!reason.trim()) {
                    toast.error("Reason is required", { autoClose: 3000 });
                    return Promise.reject(); // Prevent modal from closing
                }

                const payload = {
                    request_id: requestId,
                    status: status,
                    approved_by: userId,
                    reason: reason.trim(),
                };

                return callApi("POST", "update_shift_extension_request.php", payload)
                    .then(res => res.data)
                    .then(response => {
                        if (response.success) {
                            toast.success(response.message, { autoClose: 3000 });
                            this.listShiftExtensions(this.state.activeTabKey);
                        } else {
                            toast.error(response.message, { autoClose: 3000 });
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
        });
    };

    handleDateChange = (date, dateStr, type) => {
        this.setState({ [type]: dateStr });
    };

    handleChange = (e, propName?, fieldType?) => {
        let fieldName = fieldType === 'singleselect' ? propName : e.target.name;
        let fieldValue = fieldType === 'singleselect' ? e.value : e.target.value;

        this.setState({ [fieldName]: fieldValue });
    }

    disabledDate = (current) => {
        // Disable dates after today and dates before the last 3 months
        return current && (current > moment().endOf('day') || current < moment().subtract(3, 'months').startOf('day'));
    };

    handleRequestExtend = () => {
        this.setState({ showShiftModal: true });
    };

    handleCloseModal = () => {
        this.setState({ showShiftModal: false });
    }

    handleSubmitExtension = (extensionData) => {
        // Here you can call your backend API to save extension request
        this.setState({ isLoading: true });
        const user = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";
        const role_label = user ? JSON.parse(user)["role_label"] : "";
        // const isAdmin = ["Admin", "Super Admin"].includes(role_label);
        const isAdminAccess = this.state.pageDynamic && this.state.pageDynamic.find((page: any) => page.page_name === "Shift List" && page.status == true);

        const { extendedStart, extendedEnd, reason, extendedEmpId, extendedDate } = extensionData;
        const userShiftStartTime = localStorage.getItem("shiftStartTime") ?? '';
        const userShiftEndTime = localStorage.getItem("shiftEndTime") ?? '';
        const shiftType = localStorage.getItem("shiftType") ?? '';

        const isNotValid = !isAdminAccess ? (isEmpty(extendedDate) || isEmpty(extendedStart) || isEmpty(extendedEnd) || isEmpty(reason)) : (isEmpty(extendedDate) || isEmpty(extendedStart) || isEmpty(extendedEnd) || isEmpty(reason) || isEmpty(extendedEmpId));

        if (isNotValid) {
            toast.error("Please fill all.", { autoClose: 3000 });
            return;
        }

        const selectUser: any = isAdminAccess && this.state.users.find(
            (user: any) => String(user.id) === String(extendedEmpId)
        );

        if (isAdminAccess && isEmpty(selectUser.shift_end_time)) {
            toast.error("Shift time not set for this user.", {
                autoClose: 3000
            });
            return;
        }

        const payload = {
            "user_id": isAdminAccess ? extendedEmpId : userId,
            "shiftType": !isAdminAccess ? JSON.parse(shiftType) : selectUser.shiftType,
            "current_start_time": !isAdminAccess ? JSON.parse(userShiftStartTime) : selectUser.shift_start_time,
            "current_end_time": !isAdminAccess ? JSON.parse(userShiftEndTime) : selectUser.shift_end_time,
            "requested_date": extendedDate,
            "requested_start_time": extendedStart,
            "requested_end_time": extendedEnd,
            "reason": reason,
            'auto_trigger': false,
        }

        callApi("POST", "shift_extension_request.php", payload)
            .then(res => res.data)
            .then(response => {
                if (response.success) {
                    this.listShiftExtensions(this.state.activeTabKey);
                    toast.success(response.message, {
                        autoClose: 3000,
                    });
                    this.handleCloseModal();
                } else {
                    toast.error(response.message, {
                        autoClose: 3000
                    });
                }
            })
            .catch(err => {
                console.log(err);
                this.setState({ isLoading: false });
            }).finally(() => {
                this.setState({ isLoading: false })
            });
    };

    // Function to convert hh:mm:ss to milliseconds
    convertTimeToMilliseconds = (timeStr) => {
        const [hours, minutes, seconds] = timeStr.split(':').map(Number);
        return ((hours || 0) * 3600 + (minutes || 0) * 60 + (seconds || 0)) * 1000;
    };

    downloadShiftExcel = () => {
        const { fromDate, toDate, assigned_to } = this.state;
        const user = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";
        const role_label = user ? JSON.parse(user)["role_label"] : "";
        // const isAdmin = ["Admin", "Super Admin"].includes(role_label);
        const isAdminAccess = this.state.pageDynamic && this.state.pageDynamic.find((page: any) => page.page_name === "Shift List" && page.status == true);

        this.setState({ isDownloading: true });

        if (isEmpty(fromDate) || isEmpty(toDate)) {
            toast.error("Select Date.", { autoClose: 3000 });
            return;
        }

        const payload = {
            from_dt: fromDate,
            to_dt: toDate,
            user_id: isAdminAccess ? assigned_to : userId,
        }

        callApi("POST", "shift_report_excel.php", payload)
            .then(async ({ data: { success, data } }) => {
                if (!success || !data?.length) {
                    toast.error("No data available.", { autoClose: 3000 });
                    throw new Error("No data available");
                    return;
                }

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet1');

                // Define columns
                worksheet.columns = [
                    { header: 'S.No', key: 'serial_number', width: 10 },
                    { header: 'Employee Name', key: 'requestUserName', width: 25 },
                    { header: 'Employee ID', key: 'employeeId', width: 25 },
                    { header: 'Role', key: 'role', width: 20 },
                    { header: 'Shift Type', key: 'shiftName', width: 25 },
                    { header: 'Shift Date', key: 'shift_date', width: 20 },
                    { header: 'Shift Start Time', key: 'current_start_time', width: 30 },
                    { header: 'Shift End Time', key: 'current_end_time', width: 30 },
                    { header: 'Requested Start Time', key: 'requested_start_time', width: 30 },
                    { header: 'Requested End Time', key: 'requested_end_time', width: 30 },
                    { header: 'Requested At', key: 'created_at', width: 20 },
                    { header: 'Reason for Extra Work', key: 'reason', width: 30 },
                    { header: 'Status', key: 'status', width: 20 },
                    { header: 'Approved/ Rejected By', key: 'adminUserName', width: 25 },
                    { header: 'Approved/ Rejected date', key: 'approved_dt', width: 25 },
                    { header: 'Approved/ Rejected Reason', key: 'adminReason', width: 30 },
                ];

                // Style headers
                worksheet.getRow(1).eachCell((cell) => {
                    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } };
                    cell.font = { bold: true, size: 14 };
                });

                // Add formatted data
                data.forEach((item: any, index: any) => {
                    const row = worksheet.addRow({
                        ...item,
                        serial_number: index + 1,
                        approved_dt: item.approved_dt ? parseCustomDate(item.approved_dt) : "",
                        created_at: item.created_at ? parseCustomDate(item.created_at) : "",
                    });

                    row.eachCell((cell: any, col: number) => {
                        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                        if ([6].includes(col)) {
                            cell.numFmt = 'dd-mm-yyyy'; // For date & time format
                        } else if ([11, 15].includes(col)) {
                            cell.numFmt = 'dd-mm-yyyy hh:mm:ss'; // For date & time format
                        }
                    });
                });

                // Download file
                const formattedDate = new Date().toLocaleDateString('en-GB').split('/').join('-');
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `Shift Report ${formattedDate}.xlsx`;
                link.click();
                window.URL.revokeObjectURL(link.href);
            })
            .catch((err) => {
                console.error(err);
                ToastsStore.error(err.message || "Network error, please try again.");
            })
            .finally(() => this.setState({ isDownloading: false }));
    };

    renderShiftTable = () => {
        const { shiftDetails, page, limit, totalPages, totalCount } = this.state;
        const { activeTabKey } = this.state;
        const user = localStorage.getItem("user");
        const role_label = user ? JSON.parse(user)["role_label"] : "";
        // const isAdmin = ["Admin", "Super Admin"].includes(role_label);
        const isApproveAccess = this.state.pageDynamic && this.state.pageDynamic.find((page: any) => page.page_name === "Shift Approve/Reject Button" && page.status == true);

        if (shiftDetails.length === 0) {
            return (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <p>No shift extensions found.</p>
                </div>
            );
        }

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <table className="table text-center shift-table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>User Name</th>
                                    <th>Shift Date</th>
                                    <th>Shift End Time</th>
                                    <th>Requested Start Time</th>
                                    <th>Requested End Time</th>
                                    <th>Reason</th>
                                    <th>Status</th>
                                    {activeTabKey === "Approved" && <th>Approved Reason</th>}
                                    {activeTabKey === "Rejected" && <th>Rejected Reason</th>}
                                    <th>Requested At</th>
                                    {isApproveAccess && activeTabKey === "Pending" && <th>Action</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {shiftDetails.map((ext: any, index: number) => (
                                    <tr key={ext.id}>
                                        <td>{(page - 1) * limit + index + 1}</td>
                                        <td>{ext.name}</td>
                                        <td>{ext.shift_date}</td>
                                        <td>{ext.current_end_time}</td>
                                        <td>{ext.requested_start_time}</td>
                                        <td>{ext.requested_end_time}</td>
                                        <td>{ext.reason}</td>
                                        <td>{ext.status}</td>
                                        {(activeTabKey === "Approved" || activeTabKey === "Rejected") && <td>{ext.adminReason}</td>}
                                        <td>{ext.created_at}</td>
                                        {isApproveAccess && activeTabKey === "Pending" && (
                                            <td>
                                                <button
                                                    className="btn btn-success btn-sm m-1"
                                                    onClick={() => this.handleApprove(ext.id)}
                                                >
                                                    Approve
                                                </button>
                                                <button
                                                    className="btn btn-danger btn-sm m-1"
                                                    onClick={() => this.handleReject(ext.id)}
                                                >
                                                    Reject
                                                </button>
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="d-flex justify-content-between mt-3">
                    <button
                        className="btn btn-primary"
                        disabled={page <= 1}
                        onClick={this.handlePrev}
                    >
                        Prev
                    </button>
                    <span>Page {page} of {totalPages}</span>
                    <span>Total {totalCount}</span>
                    <button
                        className="btn btn-primary"
                        disabled={page >= totalPages}
                        onClick={this.handleNext}
                    >
                        Next
                    </button>
                </div>
            </div>
        );
    };

    confirmDelete = (file) => {
        this.setState({ shiftId: file.id })
    };

    deleteShift = () => {
        const obj = {
            id: this.state.shiftId,
        };

        callApi("POST", "deleteShift.php", obj)
            .then((res) => res.data)
            .then((response) => {
                this.getShiftList();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    render() {
        const { activeTabKey, shiftList, shiftName, shiftStartTime, shiftEndTime } = this.state;
        const usersoptions = [
            { value: "", label: "All" },
            ...this.state.users
        ];

        const user = localStorage.getItem("user");
        const role_label = user ? JSON.parse(user)["role_label"] : "";
        // const isAdmin = ["Admin", "Super Admin"].includes(role_label);
        const isAdminAccess = this.state.pageDynamic && this.state.pageDynamic.find((page: any) => page.page_name === "Shift List" && page.status == true);

        // const userShiftEndTime = isAdmin ? (localStorage.getItem("shiftEndTime") ?? '') : null;
        const userShiftEndTime = null;

        const columns = [
            {
                header: "S.no",
                key: "index",
            },
            {
                header: "Shift Name",
                key: "shiftName",
            },
            {
                header: "Start Time",
                key: "shiftStartTime",
            },
            {
                header: "End Time",
                key: "shiftEndTime",
            },
            {
                header: "Actions",
                td: (file) => {
                    return (
                        <div className="btn-group mb-2 mr-2">
                            <button type="button" className="btn btn-primary">
                                Action
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <span className="sr-only">Toggle Dropdown</span>
                            </button>
                            <div
                                className="dropdown-menu"
                                x-placement="top-start"
                                style={{
                                    position: "absolute",
                                    top: "0px",
                                    left: "0px",
                                    transform: "translate3d(88px, -2px, 0px)",
                                }}
                            >
                                <a
                                    className="dropdown-item"
                                    onClick={() => {
                                        this.setState({ shiftId: file.id, shiftName: file.shiftName, shiftStartTime: file.shiftStartTime, shiftEndTime: file.shiftEndTime });
                                        $("#shift-create").modal("show");
                                    }}
                                >
                                    Edit
                                </a>
                                {isAdminAccess && (
                                    <a
                                        className="dropdown-item"
                                        style={{ float: "right" }}
                                        data-toggle="modal"
                                        data-target="#delete-user"
                                        onClick={() => this.confirmDelete(file)}
                                    >
                                        Delete
                                    </a>
                                )}
                            </div>
                        </div>
                    );
                },
            },
        ];


        return (
            <section className="pcoded-main-container">
                <ToastsContainer
                    store={ToastsStore}
                    position={ToastsContainerPosition.TOP_RIGHT}
                />
                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            <div className="main-body">
                                <div className="page-wrapper">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card p-2">
                                                <div className="card-header">
                                                    <h5 className="file-status-header">
                                                        Shift Details
                                                    </h5>

                                                    <button
                                                        className="btn btn-primary"
                                                        style={{ float: "right" }}
                                                        onClick={() => this.props.history.goBack()}
                                                    >
                                                        Back
                                                    </button>
                                                    {this.state.pageDynamic.map((page: any, index: any) => {
                                                        if (page.page_name === "Shift List" && page.status == true) {
                                                            return (
                                                                <>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary"
                                                                        style={{ float: "right" }}
                                                                        data-toggle="modal"
                                                                        data-target="#shift-create"
                                                                    >
                                                                        Create Shift
                                                                    </button>
                                                                </>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        style={{ float: "right" }}
                                                        onClick={this.handleRequestExtend}
                                                    >
                                                        Request Extension
                                                    </button>
                                                </div>
                                                <div className="card-header">
                                                    <div className="row m-2">
                                                        <div className="col-xl-2 col-md-2 col-sm-2">
                                                            <h6>From</h6>
                                                            <DatePicker
                                                                format={'DD-MM-YYYY'}
                                                                disabledDate={this.disabledDate}
                                                                value={moment(
                                                                    this.state.fromDate,
                                                                    "DD.MM.YYYY"
                                                                )}
                                                                onChange={(date, dateStr) => this.handleDateChange(date, dateStr, 'fromDate')} />
                                                        </div>
                                                        <div className="col-xl-2 col-md-2 col-sm-2">
                                                            <h6>To</h6>
                                                            <DatePicker format={'DD-MM-YYYY'}
                                                                disabledDate={this.disabledDate}
                                                                value={moment(
                                                                    this.state.toDate,
                                                                    "DD.MM.YYYY"
                                                                )}
                                                                onChange={(date, dateStr) => this.handleDateChange(date, dateStr, 'toDate')} />
                                                        </div>

                                                        {isAdminAccess &&
                                                            <div className="col-xl-2 col-md-2 col-sm-2">
                                                                <h6>Employee Name</h6>
                                                                {this.state.users && this.state.users.length > 0 && this.state.users.map((opt: any) => {
                                                                    opt.label = opt.name; opt.value = opt.id
                                                                }) &&
                                                                    <Select options={usersoptions} name="assigned_to"
                                                                        value={this.state.users.find((o: any) => o.value === this.state.assigned_to)}
                                                                        onChange={(e) => this.handleChange(e, 'assigned_to', 'singleselect')}

                                                                    />
                                                                }
                                                            </div>
                                                        }

                                                        <div className="p-3">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary"
                                                                style={{ float: 'right' }}
                                                                onClick={() => this.listShiftExtensions(activeTabKey)}
                                                                disabled={this.state.isLoading}
                                                            >

                                                                {this.state.isLoading ? (
                                                                    <i className="fa fa-spinner fa-spin"></i>
                                                                ) : "Search"}
                                                            </button>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="ml-4 mt-2 d-flex">
                                                    <button
                                                        className="download-table-xls-button excel-download-btn"
                                                        onClick={() => this.downloadShiftExcel()}
                                                        disabled={this.state.isDownloading}
                                                    >
                                                        {this.state.isDownloading ? "Downloading..." : "Download Shifts"}
                                                    </button>
                                                </div>
                                                <div className="card-body">
                                                    <Accordion className="mainAccordion">
                                                        <Tabs
                                                            defaultActiveKey="Pending"
                                                            onSelect={(key) => {
                                                                this.setState({ activeTabKey: key, ShiftDetails: [] });
                                                                if (key !== "shiftList") {
                                                                    this.listShiftExtensions(key);
                                                                } else {
                                                                    this.getShiftList();
                                                                }
                                                            }}
                                                        >
                                                            {this.state.pageDynamic.map((page: any, index: any) => {
                                                                if (page.page_name === "Shift Alert Settings" && page.status) {
                                                                    return (
                                                                        <Tab
                                                                            eventKey="alertSettings"
                                                                            title="Alert Settings"
                                                                            key={`alert-${index}`}
                                                                        >
                                                                            <AlertSlotSettings />
                                                                        </Tab>
                                                                    );
                                                                } else if (page.page_name === "Shift List" && page.status) {
                                                                    return (
                                                                        <Tab eventKey="shiftList" title="Shift List" key={`shift-${index}`}>
                                                                            <div className="row">
                                                                                <div className="col-lg-12 table-responsive">
                                                                                    {this.state.shiftList.length > 0 && (
                                                                                        <ReactFlexyTable
                                                                                            data={shiftList}
                                                                                            columns={columns}
                                                                                            sortable
                                                                                            globalSearch
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </Tab>
                                                                    );
                                                                }
                                                                return null;
                                                            })}

                                                            {["Pending", "Approved", "Rejected"].map((status) => (
                                                                <Tab eventKey={status} title={status} key={status}>
                                                                    <div className="row">
                                                                        <div className="col-lg-12 table-responsive">
                                                                            {this.renderShiftTable()}
                                                                        </div>
                                                                    </div>
                                                                </Tab>
                                                            ))}
                                                        </Tabs>
                                                    </Accordion>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <RequestShiftExtension
                    show={this.state.showShiftModal}
                    onClose={this.handleCloseModal}
                    onSubmit={this.handleSubmitExtension}
                    loading={this.state.isLoading}
                />
                <div
                    className="modal fade"
                    id="shift-create"
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{!isEmpty() ? "Update" : "Create"} Shift</h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={this.handleShift}>
                                    <div className="mb-3">
                                        <label>Shift Name</label>
                                        <input
                                            name="shiftName"
                                            className="form-control"
                                            placeholder="Enter Shift name"
                                            value={shiftName}
                                            onChange={(e) => this.handleChange(e)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label>Start Time</label>
                                        <input
                                            type="time"
                                            name="shiftStartTime"
                                            className="form-control"
                                            value={shiftStartTime}
                                            onChange={(e) => this.handleChange(e)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label>End Time</label>
                                        <input
                                            type="time"
                                            name="shiftEndTime"
                                            className="form-control"
                                            value={shiftEndTime}
                                            onChange={(e) => this.handleChange(e)}
                                        />
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <button type="submit" className="btn btn-primary me-2">
                                            Save
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="modal fade"
                    id="delete-user"
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Delete Shift</h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <h6>Are you sure you want to Delete this shift?</h6>
                                <div className="form-group">
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    data-dismiss="modal"
                                    onClick={this.deleteShift}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* THIS FOR OUT REASON MODAL */}
                <div
                    className="modal fade hide in"
                    id="out_reason"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog ">
                        <div
                            className="modal-content"
                            style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
                        >
                            <div
                                className="modal-body"
                                style={{ padding: "30px 23px 29px 24px" }}
                            >
                                <h3 style={{ margin: "auto", fontSize: "17px" }}>
                                    Please Select The Reason For To Close The File.No:
                                    {localStorage.getItem("currentfileId")}
                                </h3>
                            </div>
                            <div
                                className="form-group"
                                style={{ width: "74%", margin: "auto" }}
                            >
                                <select
                                    className="custom-select"
                                    name="outreason"
                                    value={this.state.outreason}
                                    onChange={(e) => this.onchangeReason(e)}
                                    required
                                    id="select1"
                                    style={{ marginTop: "8px" }}
                                >
                                    <option value="select">Select Your Reason</option>
                                    <option value="Query Raised">Query Raised</option>
                                    <option value=" Re-Query Raised"> Re-Query Raised</option>
                                    <option value="Hold ">Hold </option>
                                    <option value="Completed">Completed</option>
                                    <option value="Other">Others</option>
                                </select>
                                {this.state.selectVal ? (
                                    <p
                                        style={{
                                            color: "red",
                                            textAlign: "center",
                                            fontSize: "16px",
                                        }}
                                    >
                                        Please Select Your Reason{" "}
                                    </p>
                                ) : null}
                            </div>
                            <div className="modal-footer" style={{ marginTop: "27px" }}>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={this.state.isLoading}
                                    onClick={this.outimeGet}
                                    style={{ width: "76px", fontSize: "17px" }}
                                >
                                    {" "}
                                    {this.state.isLoading ? (
                                        <i className="fa fa-spinner fa-spin"></i>
                                    ) : (
                                        "OK"
                                    )}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    onClick={this.BacktoFile}
                                    style={{
                                        width: "107px",
                                        fontSize: "14px",
                                        border: "1px solid black",
                                        height: "43px",
                                    }}
                                >
                                    {" "}
                                    Back To File
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* OTHER REASON MODAL */}
                <div
                    className="modal hide fade in"
                    id="another-reason"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog ">
                        <div
                            className="modal-content"
                            style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
                        >
                            <h5 style={{ marginTop: "31px", textAlign: "center" }}>
                                Please Type a Reason To Close The File.No:{" "}
                                {localStorage.getItem("currentfileId")}{" "}
                            </h5>
                            <div
                                className="modal-body"
                                style={{ padding: "30px 23px 29px 24px" }}
                            >
                                {/* <div className="col-md-5"> */}
                                <div
                                    className="form-group"
                                    style={{ width: "98%", margin: "auto" }}
                                >
                                    <textarea
                                        className="form-control"
                                        placeholder="Type Your Reason"
                                        name="outreason"
                                        onChange={this.onchange}
                                    />
                                    {this.state.selectVal ? (
                                        <p
                                            style={{
                                                color: "red",
                                                textAlign: "center",
                                                fontSize: "16px",
                                            }}
                                        >
                                            Please Select Your Reason{" "}
                                        </p>
                                    ) : null}
                                </div>
                                {/* </div> */}
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => this.outimeGet()}
                                    style={{ width: "76px", fontSize: "17px" }}
                                    disabled={this.state.isLoading}
                                >
                                    {" "}
                                    {this.state.isLoading ? (
                                        <i className="fa fa-spinner fa-spin"></i>
                                    ) : (
                                        "OK"
                                    )}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    onClick={() => this.previousPop()}
                                    // onClick={this.disableModalHandler}
                                    style={{
                                        width: "76px",
                                        fontSize: "17px",
                                        border: "1px solid black",
                                    }}
                                >
                                    {" "}
                                    Back
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default ShiftDetails;
